import {
  SELECTED_EMPLOYEES,
} from '@/store/actions/payroll';

const mutations = {
  [SELECTED_EMPLOYEES]: (state, value) => {
    state.selectedEmployees = value;
  },
};

const getters = {
  getSelectedEmployees: (state) => state.selectedEmployees,
};

const state = () => ({
  selectedEmployees: [],
});

export default () => ({
  getters,
  mutations,
  state,
});
